// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__-9eVi","projects_title":"Projects_projects_title__3ljHJ","projects":"Projects_projects__Mqq8x"};